//authentication
const SEND_TENANT_OTP='tenant/send-otp'
const VERIFY_TENANT_OTP = 'tenant/verify-otp'
//home page
const GET_TENANT_USER_DETAILS = 'tenant/get-user-details'
const GET_TENANT_PROPERTIES = 'tenant/get-properties'
const GET_TENANT_HISTORY = 'tenant/get-history'

//financials
const GET_TENANT_FINANCIALS = 'tenant/get-financials'
const GET_TENANT_PAYMENT = 'tenant/get-payment'   

export {
    SEND_TENANT_OTP, VERIFY_TENANT_OTP, GET_TENANT_USER_DETAILS, GET_TENANT_PROPERTIES,
    GET_TENANT_HISTORY, GET_TENANT_FINANCIALS, GET_TENANT_PAYMENT
}